import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import type { CognitoFrontConfig } from "./idpSession";

/**
 * El cliente OIDC de Cognito, compartido por AuthProvider y CognitoBridge. La renovación
 * automática va apagada: la hace el puente, una sola a la vez por pestaña, y con este mismo
 * cliente porque el signinSilent de react-oidc-context se traga los errores.
 */
export function crearUserManager(config: CognitoFrontConfig, origin: string): UserManager {
  return new UserManager({
    authority: config.authority,
    client_id: config.clientId,
    redirect_uri: origin,
    post_logout_redirect_uri: origin,
    response_type: "code",
    scope: "openid email profile",
    // Como Auth0 hoy (cacheLocation: localstorage): la sesión sobrevive a cerrar la pestaña.
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: false,
    monitorSession: false,
  });
}
